import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Col, Row } from "reactstrap";
import { ValidatorForm } from "react-material-ui-form-validator";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
// import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import InputAdornment from "@material-ui/core/InputAdornment";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import Tooltip from "@material-ui/core/Tooltip";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import ToggleButton from "@mui/material/ToggleButton";
import moment from "moment-timezone";
import FetchServerData from "../../../provider/FetchServerData";
import {
  GetProfile_Url,
  ProfileList_Url,
  UpdateProfile_Url,
  deleteAccount_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import store from "../../../redux/store";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import "./Profile.css";
import PtsAlert from "../ptsAlert/PtsAlert";
import SaveButton from "../buttons/SaveButton";
import CancelIconButton from "../buttons/CancelIconButton";
// import EditIconButton from "../buttons/EditIconButton";
class Profile extends Component {
  header = store.getState().header.header;
  profileList = [];
  breadCrumb = [{ pageid: "", uiname: "My Profile" }];
  activeMenu = store.getState().activeMenu.activeMenu;
  profile = store.getState().appUserData.appUserData.appuser?.profile;

  constructor(props) {
    super(props);
    let action = props.action;
    if (!action && props.state) {
      action = props.state.action;
    }
    if (
      action &&
      Utils.equalsIgnoreCase(
        action,
        "view" || Utils.equalsIgnoreCase(action, "edit")
      )
    ) {
      this.getProfileDetails();
    }
    let twoFactorList = [
      {
        id: "1",
        name: "on",
      },
      {
        id: "2",
        name: "off",
      },
    ];
    this.state = {
      action: action,
      address: {},
      email: "",
      password: "",
      firstName: "",
      lastName: "",
      phoneNumber: "",
      jobTitle: "",
      phone: "",
      officePhone: "",
      eIn: "",
      companyName: "",
      smsTAndCUrl: "",
      smsPrivacyPolicyUrl: "",
      businessType: null,
      businessIndustry: null,
      isStatus: true,
      id: "",
      getUpdatePermission: false,
      getDeletePermission: false,
      userProfile: null,
      userStatus: "Active",
      profileList: [],
      officePhoneNumber: "",
      twoFactorList: twoFactorList,
      twoFactor: Utils.getArrayElement(twoFactorList, 0),
      registrationDate: "",
      accountPassword: "",
      showPassword: false,
      authorizedCaregiver: false,
      confirmWindowOpen: false,
      sendOtpByEmail: false,
      sendOtpByText: true,
      render: false,
    };
    this.getProfileDetails();
  }

  componentDidMount() {
    this.getUserProfileList();
  }

  async getUserProfileList() {
    const postObject = {
      header: this.header,
    };
    await FetchServerData.callPostService(ProfileList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let profileList = output.data.profileList;
          this.setState({
            profileList: profileList,
          });
        } else {
        }
      }
    );
  }
  handleUserNameChange(e) {
    this.setState({ userName: e.target.value });
  }
  handleFnameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLnameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  handleJobTitleChange(e) {
    this.setState({ jobTitle: e.target.value });
  }

  handlePhoneChange(e) {
    let val = e.target.value;

    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);

      this.setState({
        phone: value,
        phoneNumber: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleOfficePhoneChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        officePhone: value,
        officePhoneNumber: e.target.value.replace(/-/g, ""),
      });
    }
  }

  editProfile(e) {
    this.setState({ action: "edit" });
  }
  handleAddressChange(address) {
    this.setState({ address: address });
  }
  onClickCancel(e) {
    this.setState({ action: "view" });
  }
  handleStatusChange(e) {
    this.setState({ isStatus: !this.state.isStatus });
  }
  handleUserProfileChange(selectedValue) {
    this.setState({ userProfile: selectedValue });
  }
  handleTwoFactorChange(selectedValue) {
    this.setState({ twoFactor: selectedValue });
  }

  getUsageDetails(data) {
    const postObject = {
      header: this.header,
      usageDetails: {
        month: data?.month,
        year: data?.year,
      },
    };
    FetchServerData.callPostService("/usagems/getUsage", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
        }
      }
    );
  }
  getProfileDetails() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(GetProfile_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let profileDetails = output.data.appuser;
          // let usageDetails = output.data.usageDetails;
          let getPermission = Utils.getRolePermission(["*"]);
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let userStatus = "";
          if (userStatus === null) {
            userStatus = false;
          } else {
            if (profileDetails?.appuserStatus?.status === "Active") {
              userStatus = true;
            } else {
              userStatus = false;
            }
          }
          let phone = Utils.phoneNumberFormate(profileDetails?.phone);
          let officePhone = Utils.phoneNumberFormate(
            profileDetails?.officePhone
          );
          this.setState({
            render: true,
            id: profileDetails.id,
            firstName: profileDetails.firstName,
            lastName: profileDetails.lastName,
            email: profileDetails.email,
            phone: phone,
            registrationDate: profileDetails?.registrationDate,
            phoneNumber: profileDetails?.phone?.replace(/-/g, ""),
            officePhone: officePhone,
            officePhoneNumber: profileDetails?.officePhone?.replace(/-/g, ""),
            address: profileDetails?.address,
            eIn: profileDetails.organization?.ein,
            companyName: profileDetails.organization?.name,
            businessType: profileDetails.organization?.businessType,
            businessIndustry: profileDetails.organization?.businessIndustry,
            companyAddress: profileDetails.organization?.address,
            jobTitle: profileDetails.jobTitle,
            isStatus: userStatus,
            userStatus: profileDetails.appuserStatus?.status,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
            userProfile: profileDetails.profile,
            companyType: profileDetails.organization.companyType,
            smsTAndCUrl: profileDetails.organization.tandc,
            smsPrivacyPolicyUrl: profileDetails.organization.privacyPolicy,
            sendOtpByEmail: profileDetails.sendOtpByEmail,
            sendOtpByText: profileDetails.sendOtpByText,
          });
        } else {
        }
      }
    );
  }

  updateProfileInBackend(e) {
    let userStatus;
    if (this.state.isStatus === true) {
      userStatus = "Active";
    } else {
      userStatus = "Inactive";
    }

    const postObject = {
      header: this.header,
      appuser: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        phone: this.state.phoneNumber,
        // officePhone: this.state.officePhoneNumber,
        // jobTitle: this.state.jobTitle,
        tenant: this.header.tid,
        id: this.state.id,
        sendOtpByEmail: this.state.sendOtpByEmail,
        sendOtpByText: this.state.sendOtpByText,
        // address: {
        //   id: this.addressRef.current.state.id,
        //   line: this.addressRef.current.state.line,
        //   state: {
        //     name: this.addressRef.current.state.state.name,
        //     code: this.addressRef.current.state.state.code,
        //     id: this.addressRef.current.state.state.id,
        //     country: {
        //       name: this.addressRef.current.state?.country?.name,
        //       code: this.addressRef.current.state?.country?.code,
        //       isocode: this.addressRef.current.state?.country?.isocode,
        //       namecode: this.addressRef.current.state?.country?.namecode,
        //       id: this.addressRef.current.state?.country?.id,
        //     },
        //   },
        //   city: this.addressRef.current.state.city,
        //   zipcode: this.addressRef.current.state.zipCode,
        // },
        appuserStatus: {
          status: userStatus,
        },
        profile: {
          name: this.state.userProfile?.name,
          id: this.state.userProfile?.id,
          status: this.state.userProfile?.status,
        },
      },
    };
    FetchServerData.callPostService(UpdateProfile_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          this.setState({ action: "view", render: true });
          this.getProfileDetails();
        } else {
        }
      })
      .catch((error) => { });
  }

  deleteProfileInBackend() {
    const postObject = {
      header: this.header,
      credential: this.state.accountPassword,
    };
    FetchServerData.callPostService(deleteAccount_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/");
        } else {
        }
      }
    );
  }

  handleAuthorizedClose = () => {
    this.setState({ authorizedCaregiver: !this.state.authorizedCaregiver });
  };
  handleOpenAuthorized = () => {
    this.setState({ authorizedCaregiver: true });
  };

  toDeleteAuthorizedConfirmationWindow = () => {
    this.setState({ confirmWindowOpen: true, authorizedCaregiver: false });
  };

  handleConfirmWindowClose = () => {
    this.setState({ confirmWindowOpen: !this.state.confirmWindowOpen });
  };

  handlePasswordChange(e) {
    this.setState({ accountPassword: e.target.value });
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  viewCancel() {
    this.props.navigate(this.activeMenu);
  }

  handleSendOtpByEmailChange(e) {
    this.setState({ sendOtpByEmail: e.target.checked, error: false });
  }
  handleSendOtpByTextChange(e) {
    this.setState({ sendOtpByText: e.target.checked, error: false });
  }

  render() {
    this.addressRef = React.createRef();
    if (this.state.action === "edit") {
      return this.editProfileDetails();
    } else {
      return this.viewProfileDetails();
    }
  }
  viewProfileDetails() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            domainObject={this.state.firstName + " " + this.state.lastName}
            name="My Profile"
            editCallback={!this.header.isAp && this.editProfile.bind(this)}
            // backCallback={this.viewCancel.bind(this)}
            // deleteCallback={this.handleOpenAuthorized.bind(this)}
            getUpdatePermission={this.state.getUpdatePermission}
            getDeletePermission={this.state.getDeletePermission}
          />
          <div className="row g-3">
            <div className="col-md-6">
              <div className="card" id="giveBeeCard">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>My Profile</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <label
                          className="col-sm-3 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          Name
                        </label>
                        <div className="col-sm-9" id="givbeeText">
                          <span>
                            {this.state.firstName} {this.state.lastName}
                          </span>
                        </div>
                      </div>

                      <div className="row">
                        <label
                          className="col-sm-3 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          User ID
                        </label>
                        <div className="col-sm-9" id="givbeeText">
                          <span>{this.state.email}</span>
                        </div>
                      </div>

                      {!this.header.isAp && (
                        <div className="row">
                          <label
                            className="col-sm-3 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Mobile Phone
                          </label>
                          <div className="col-sm-9" id="givbeeText">
                            <span>{this.state.phone}</span>
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <label
                          className="col-sm-3 col-form-label fw-bold"
                          htmlFor="basic-default-name"
                          id="assetFormLabel"
                        >
                          User Type
                        </label>
                        <div className="col-sm-9" id="givbeeText">
                          <span>{this.state.userProfile?.name}</span>
                        </div>
                      </div>
                      {!this.header.isAp && (
                        <>
                          {/* <div className="row">
                            <label
                              className="col-sm-3 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Status
                            </label>
                            <div className="col-sm-9" id="givbeeText">
                              <span>{this.state.userStatus}</span>
                            </div>
                          </div> */}
                          <div className="row">
                            <label
                              className="col-sm-3 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Registration Date
                            </label>
                            <div className="col-sm-9" id="givbeeText">
                              <span>
                                {this.state.registrationDate
                                  ? moment(this.state.registrationDate).format(
                                    "DD MMM YYYY"
                                  )
                                  : ""}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {!this.header.isAp && (
              <div className="col-md-6">
                <div className="card" id="giveBeeCard">
                  <div
                    className="card-header d-flex align-items-center justify-content-between"
                    id="assetCardHeader"
                  >
                    <h6 className="mb-0" id="headerLabel">
                      <b>Account Security Settings</b>
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row mt-1">
                      <div className="col-md-12">
                        <div className="row">
                          <label
                            className="col-sm-4 col-form-label fw-bold"
                            htmlFor="basic-default-name"
                            id="assetFormLabel"
                          >
                            Password:
                          </label>
                          <div
                            className="col-sm-3 align-self-center"
                            id="givbeeText"
                          >
                            <span>*********</span>
                          </div>
                          <div
                            className="col-sm-5 align-self-center"
                            id="givbeeText"
                          >
                            <NavLink to="/changePassword">
                              Change Password
                            </NavLink>
                          </div>
                        </div>
                        <>
                          <div className="row mt-4">
                            <label
                              className="col-sm-12 col-form-label fw-bold"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Two-factor Authentication
                              <InfoTooltip
                                data="This Two-Factor Authentication feature provides you with higher-level of account security by requiring that you enter a unique password after you correctly enter your login ID and password. The unique password is delivered to your mobile phone, by text message, each time you log in.
                            The use of Two-Factor Authentication is recommended."
                                style={{
                                  float: "right",
                                }}
                              />
                            </label>
                          </div>
                          <div className="row mt-2">
                            <label
                              className="col-sm-4 col-form-label"
                              htmlFor="basic-default-name"
                              id="assetFormLabel"
                            >
                              Send verification code to:
                            </label>
                            <div className="col-sm-8" id="givbeeText">
                              <span>
                                {this.state.sendOtpByText &&
                                  this.state.sendOtpByEmail
                                  ? "SMS, Email"
                                  : this.state.sendOtpByText
                                    ? "SMS"
                                    : this.state.sendOtpByEmail
                                      ? "Email"
                                      : ""}
                              </span>
                            </div>
                          </div>
                        </>
                        <div
                          className="row pt-2 align-items-end"
                          style={{ height: "100px" }}
                        >
                          {this.state.userProfile?.name ===
                            "Super Admin User" && (
                              <span
                                className="text-end"
                                style={{ fontSize: "13px", fontWeight: "600" }}
                              >
                                <NavLink
                                  onClick={this.handleOpenAuthorized.bind(this)}
                                >
                                  <i class="fas fa-user-times"></i> Close Account
                                </NavLink>
                              </span>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Dialog
            open={this.state.authorizedCaregiver}
            onClose={this.handleAuthorizedClose.bind(this)}
            onHide={this.close}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <Row style={{ marginRight: "auto", marginLeft: "auto" }}>
                <Col md={12} style={{ textAlign: "center" }}>
                  <ErrorOutlineIcon
                    style={{
                      border: "2px solid #fff",
                      borderRadius: "25%",
                      background: "#066f72 !important",
                      color: "red",
                      fontSize: "50px",
                    }}
                  />
                </Col>
              </Row>

              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "18px" }}>
                  You will no longer be able to use GivBee services anymore. Do
                  you want to continue?
                </p>
              </span>
            </DialogContent>
            <DialogActions
              style={{
                padding: "1em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
                onClick={(e) => this.toDeleteAuthorizedConfirmationWindow(e)}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleAuthorizedClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.confirmWindowOpen}
            onClose={this.handleConfirmWindowClose.bind(this)}
            onHide={this.close}
            style={{ padding: "1em" }}
          >
            <DialogContent style={{ marginTop: "2em" }}>
              <span style={{ textAlign: "center" }}>
                <h2 style={{ fontSize: "20px" }}>
                  Please enter your Password{" "}
                </h2>
              </span>
              <Row className="mt-4">
                <Col
                  md={12}
                  style={{ marginLeft: "auto", marginRight: "auto" }}
                >
                  <TextField
                    title=""
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus={true}
                    name="password"
                    type={this.state.showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="off"
                    onChange={this.handlePasswordChange.bind(this)}
                    value={this.state.accountPassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={this.handleClickShowPassword.bind(this)}
                          >
                            {this.state.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Col>
              </Row>
            </DialogContent>
            <DialogActions
              style={{
                padding: "2em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
                onClick={(e) => this.deleteProfileInBackend(e)}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleConfirmWindowClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    }
  }

  editProfileDetails() {
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          domainObject="My Profile"
          name="My Profile"
        />
        <ValidatorForm
          ref="form"
          id="multiStepsForm"
          onSubmit={this.updateProfileInBackend.bind(this)}
        >
          <div className="row g-3 mt-3">
            <div className="col-md-6">
              <div className="card " id="giveBeeCard">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>My Profile</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 align-self-center">
                      <div className="row">
                        <div className="col-sm-6">
                          <label
                            className="form-label"
                            htmlFor="multiStepsFirstName"
                          >
                            First Name*
                          </label>
                          <input
                            required
                            title=""
                            type="text"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.firstName}
                            onChange={this.handleFnameChange.bind(this)}
                          />
                        </div>
                        <div className="col-sm-6">
                          <label
                            className="form-label"
                            htmlFor="multiStepsLastName"
                          >
                            Last Name*
                          </label>
                          <input
                            title=""
                            required
                            type="text"
                            value={this.state.lastName}
                            onChange={this.handleLnameChange.bind(this)}
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="row g-3 mt-2 ">
                        {/* <div className="col-sm-6">
                          <label className="form-label" htmlFor="multiStepsEmail">
                            User ID*
                          </label>
                          <input
                            title=""
                            required
                            type="email"
                            disabled={this.profile?.name !== "Admin"}
                            value={this.state.email}
                            onChange={this.handleEmailChange.bind(this)}
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            aria-label="john.doe"
                          />
                        </div> */}
                        <div className="col-sm-6">
                          <label
                            className="form-label"
                            htmlFor="multiStepsMobile"
                          >
                            Mobile Phone*
                          </label>

                          <input
                            title=""
                            required
                            type="text"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.phone}
                            onChange={this.handlePhoneChange.bind(this)}
                          />
                        </div>
                      </div>
                      {/* <div className="row g-3 mt-2">
                        <div className="col-sm-6">
                          <label
                            className="form-label MuiAutocomplete-label"
                            htmlFor="collapsible-userProfile"
                          >
                            User Type*
                          </label>

                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            disabled={this.profile?.name !== "Admin"}
                            ListboxProps={{
                              className: "custom-listbox",
                            }}
                            options={this.state.profileList}
                            value={this.state.userProfile}
                            getOptionLabel={(option) => option.name}
                            defaultValue={this.state.userProfile}
                            onChange={(event, value) => {
                              this.handleUserProfileChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                style={{ background: "#fff" }}
                              />
                            )}
                          />
                        </div>
                        <div className="col-sm-6" style={{ marginTop: "auto" }}>
                          <label
                            className="form-label"
                            htmlFor="multiStepsMobile"
                          >
                            Status
                          </label>

                          <Tooltip
                            title="Please click 'Click’ to change Status"
                            classes={{ popper: "custom-tooltip" }}
                          >
                            <span className="ms-4">
                              <ToggleButton
                                value={
                                  this.state.isStatus ? "Active" : "InActive"
                                }
                                className="ToggleButtonActive"
                                onChange={this.handleStatusChange.bind(this)}
                                disabled={this.profile?.name !== "Admin"}
                                style={
                                  this.state.isStatus
                                    ? {
                                      background: "#0B6F9D",
                                      color: "#fff",
                                      height: "33px",
                                      width: "80px",
                                      borderRadius: "5px",
                                      textTransform: "none",
                                    }
                                    : {
                                      background: "#D7DBDD",
                                      color: "#000",
                                      height: "33px",
                                      width: "80px",
                                      borderRadius: "5px",
                                      textTransform: "none",
                                    }
                                }
                              >
                                {this.state.isStatus ? "Active" : "InActive"}
                              </ToggleButton>
                            </span>
                          </Tooltip>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card " id="giveBeeCard">
                <div
                  className="card-header d-flex align-items-center justify-content-between"
                  id="assetCardHeader"
                >
                  <h6 className="mb-0" id="headerLabel">
                    <b>Account Security Settings</b>
                  </h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <label
                      className="col-sm-12 col-form-label fw-bold"
                      htmlFor="basic-default-name"
                      id="assetFormLabel"
                    >
                      Two-factor Authentication
                      <InfoTooltip
                        data="This Two-Factor Authentication feature provides you with higher-level of account security by requiring that you enter a unique password after you correctly enter your login ID and password. The unique password is delivered to your mobile phone, by text message, each time you log in.
                            The use of Two-Factor Authentication is recommended."
                        style={{
                          float: "right",
                        }}
                      />
                    </label>
                  </div>
                  <div className="row mt-2">
                    <div className="col-md-4 d-flex">
                      <label className="form-label" htmlFor="multiStepsPass">
                        Send verification code to:
                      </label>
                    </div>
                    <div className="col-md-2 d-flex ms-1">
                      <span className="me-1" style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          value={this.state.sendOtpByText}
                          onChange={(e) => this.handleSendOtpByTextChange(e)}
                          checked={this.state.sendOtpByText}
                        />
                      </span>
                      <p className="form-label" htmlFor="collapsible-lastname">
                        SMS
                      </p>
                    </div>
                    <div className="col-md-2 d-flex">
                      <span className="me-1" style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          value={this.state.sendOtpByEmail}
                          onChange={(e) => this.handleSendOtpByEmailChange(e)}
                          checked={this.state.sendOtpByEmail}
                        />
                      </span>
                      <p className="form-label " htmlFor="collapsible-lastname">
                        email
                      </p>
                    </div>
                    <div className="col-sm-5" id="givbeeText"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-12  justify-content-between"
            style={{ marginTop: "2em", textAlign: "center" }}
          >
            <SaveButton id="saveButton" type="submit" />
            <CancelIconButton onClick={this.onClickCancel.bind(this)} />
          </div>
        </ValidatorForm >
      </>
    );
  }
}

export default withRouter(Profile);
